import React from 'react';
import NumberFormat from 'react-number-format';

function sumByQtde(rowsCount, rowGetter, column) {
  let totalQtde = 0;
  for (let index = 0; index < rowsCount; index++) {
    const columnValue = rowGetter(index)[column.key];
    if (!columnValue) continue;
    totalQtde += parseInt(columnValue, 10);
  }
  return totalQtde;
}

export default function Summary({ rowsCount, rowGetter, column }) {
  return (
    <div className="d-flex justify-content-end">
      <NumberFormat
        displayType="text"
        thousandSeparator="."
        decimalSeparator=","
        value={sumByQtde(rowsCount, rowGetter, column)}
      />
    </div>
  )
}
